import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row items-center q-gutter-sm" }
const _hoisted_2 = { class: "text-grey-5" }
const _hoisted_3 = { class: "row no-wrap items-center justify-end" }
const _hoisted_4 = {
  key: 3,
  style: {"width":"33px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card = _resolveComponent("q-card")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_card, {
      square: "",
      flat: "",
      bordered: "",
      class: "my-card bg-grey-1 vertical-bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar_title, { class: "text-weight-bold text-grey-brand" }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Stream Manager ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_q_btn, {
              flat: "",
              round: "",
              dense: "",
              icon: "refresh",
              onClick: _ctx.refresh
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, null, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("Refresh sessions", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_q_btn, {
              flat: "",
              round: "",
              dense: "",
              icon: "close",
              onClick: _ctx.onClose
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_card_section, { class: "q-pt-none q-pb-sm" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_q_select, {
                modelValue: _ctx.selectedDevice,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDevice) = $event)),
                options: _ctx.filteredDeviceOptions,
                label: "Select device",
                dense: "",
                outlined: "",
                "option-label": "label",
                "option-value": "uid",
                "emit-value": "",
                "map-options": "",
                "use-input": "",
                "input-debounce": "200",
                class: "col",
                loading: _ctx.loadingDevices,
                onPopupShow: _ctx.fetchDevices,
                onFilter: _ctx.onFilterDevices
              }, {
                option: _withCtx((scope) => [
                  _createVNode(_component_q_item, _normalizeProps(_guardReactiveProps(scope.itemProps)), {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.opt.label), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_badge, {
                            color: scope.opt.isConnected ? 'green' : 'grey',
                            label: scope.opt.isConnected ? 'online' : 'offline'
                          }, null, 8, ["color", "label"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 1
              }, 8, ["modelValue", "options", "loading", "onPopupShow", "onFilter"]),
              _createVNode(_component_q_btn, {
                dense: "",
                outline: !_ctx.onlineOnly,
                color: _ctx.onlineOnly ? 'green' : 'grey',
                icon: "wifi",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onlineOnly = !_ctx.onlineOnly))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_tooltip, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.onlineOnly ? 'Showing online only' : 'Showing all devices'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["outline", "color"]),
              _createVNode(_component_q_btn, {
                dense: "",
                color: "primary",
                label: "Start",
                disable: _ctx.selectedDevice === null,
                onClick: _ctx.startSession
              }, null, 8, ["disable", "onClick"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_q_separator),
        (_ctx.activeDeviceSessions.length === 0)
          ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "text-grey-6 text-center q-py-md" }, " No active stream sessions ", -1)
              ]))]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_q_list, {
              key: 1,
              separator: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeDeviceSessions, (device) => {
                  return (_openBlock(), _createBlock(_component_q_item, {
                    key: device.uid,
                    class: _normalizeClass(["q-py-sm", { 'stream-active-item': _ctx.isStreamOpen(device.uid) }])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, { class: "text-weight-medium" }, {
                            default: _withCtx(() => [
                              _createTextVNode(" UID " + _toDisplayString(device.uid), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_item_label, { caption: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(device.activeSessionCount) + " " + _toDisplayString(device.activeSessionCount === 1 ? 'viewer' : 'viewers'), 1)
                            ]),
                            _: 2
                          }, 1024),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(device.sessions, (session) => {
                            return (_openBlock(), _createBlock(_component_q_item_label, {
                              key: session.streamSessionId,
                              caption: "",
                              class: "q-ml-sm"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(session.userName) + " ", 1),
                                _createElementVNode("span", _hoisted_2, " — joined " + _toDisplayString(_ctx.formatTime(session.createdDate)), 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_item_section, {
                        side: "",
                        style: {"min-width":"80px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            (!_ctx.isStreamOpen(device.uid))
                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                  key: 0,
                                  flat: "",
                                  dense: "",
                                  color: "primary",
                                  icon: "play_arrow",
                                  onClick: ($event: any) => (_ctx.openStream(device.uid))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                        _createTextVNode("Open stream", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : (_openBlock(), _createBlock(_component_q_icon, {
                                  key: 1,
                                  name: "sensors",
                                  color: "green",
                                  size: "sm",
                                  class: "q-mr-xs"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                        _createTextVNode("Active in realtime plot", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })),
                            (_ctx.isViewerOn(device))
                              ? (_openBlock(), _createBlock(_component_q_btn, {
                                  key: 2,
                                  flat: "",
                                  dense: "",
                                  color: "negative",
                                  icon: "logout",
                                  onClick: ($event: any) => (_ctx.leaveStream(device.uid))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_tooltip, null, {
                                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                        _createTextVNode("Leave session", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_4))
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["class"]))
                }), 128))
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ], 512)), [
    [_vShow, _ctx.showStreamManager]
  ])
}